import { Lemonade, setConfig, useLemonadeQuestion } from '@oneclick/react-lemonade-editor';
import PropTypes from 'prop-types';
import React, { forwardRef, useImperativeHandle } from 'react';

// Configure Lemonade once per module
setConfig({
  mathRenderEngine: 'katex',
  chartsEnable: true,
});

function LemonadeActivityInner({ exercise, onInteraction }, ref) {
  const {
    exercise: { Question, Feedback, questionApi: store },
  } = useLemonadeQuestion({
    data: exercise,
  });

  useImperativeHandle(
    ref,
    function () {
      return {
        checkAnswers: function () {
          return store.checkAnswers();
        },
        getResponse: function () {
          return store.getResponse();
        },
        getUserResponse: function () {
          return store.getUserResponse();
        },
        showSolutions: function () {
          return store.showSolutions();
        },
        reset: function () {
          return store.reset();
        },
        setResponse: function (value) {
          return store.setResponse(value);
        },
      };
    },
    [store]
  );

  return (
    <Lemonade>
      <Question
        changed={function () {
          if (onInteraction) onInteraction(true);
        }}
      />
      <Feedback />
    </Lemonade>
  );
}

LemonadeActivityInner.propTypes = {
  exercise: PropTypes.object.isRequired,
  onInteraction: PropTypes.func,
};

const LemonadeActivity = React.memo(forwardRef(LemonadeActivityInner), function propsAreEqual(prevProps, nextProps) {
  const prevId = prevProps.exercise?.id || prevProps.exercise?.data?.id;
  const nextId = nextProps.exercise?.id || nextProps.exercise?.data?.id;
  return prevId === nextId;
});

export default LemonadeActivity;
